export default __webpack_public_path__ + "static/media/responsive-design-ss-1.cb377644.png";